import { render, staticRenderFns } from "./AjoutLieu.vue?vue&type=template&id=0baa5050&"
import script from "./AjoutLieu.vue?vue&type=script&lang=js&"
export * from "./AjoutLieu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports